import { Check, Circle } from "lucide-react";
import { checkPasswordRules } from "../lib/passwordPolicy";

/**
 * Live checklist for password strength. Renders each policy rule and marks it
 * satisfied as the user types. Colours are theme-token driven so it works in
 * both the auth (light-only) shell and the in-app modals.
 */
export default function PasswordStrengthChecklist({ password, testid = "password-rules" }) {
  const rules = checkPasswordRules(password);
  return (
    <ul
      data-testid={testid}
      style={{
        listStyle: "none",
        padding: "10px 12px",
        margin: "4px 0 12px 0",
        border: "1px solid var(--pg-border, #e6e4dc)",
        borderRadius: 8,
        background: "var(--pg-surface-2, rgba(0,0,0,0.03))",
        fontSize: 12,
        lineHeight: 1.7,
      }}
    >
      {rules.map((r) => (
        <li
          key={r.key}
          data-testid={`${testid}-${r.key}`}
          data-ok={r.ok ? "1" : "0"}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            color: r.ok ? "var(--pg-accent-deep, #34a853)" : "var(--pg-text-mute, #6b6b6b)",
            transition: "color 120ms ease",
          }}
        >
          {r.ok
            ? <Check size={14} strokeWidth={2.6} />
            : <Circle size={12} strokeWidth={2} style={{ opacity: 0.5 }} />}
          <span>{r.label}</span>
        </li>
      ))}
    </ul>
  );
}
